
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.611 8.502a.498.498 0 00-.598.377l-2.877 12.729-4.161-12.773c-.068-.208-.29-.327-.484-.345a.5.5 0 00-.472.362l-3.645 12.757L7.983 8.861a.5.5 0 10-.966.258l3.856 14.5a.5.5 0 00.479.371h.005a.498.498 0 00.48-.362L15.53 10.7l4.217 12.945c.07.214.269.378.499.344a.497.497 0 00.464-.389l3.277-14.5a.498.498 0 00-.377-.598zM15.03 6.988a.498.498 0 00.597-.377L16.986.599a.498.498 0 00-.377-.598.497.497 0 00-.598.377L14.652 6.39a.498.498 0 00.377.598zm-7.766-.35L8.531 2.2l1.45 4.454a.5.5 0 00.951-.308L8.975.335c-.068-.21-.29-.322-.484-.346a.499.499 0 00-.472.362L6.303 6.363a.5.5 0 10.961.275zm-1.8 4.477a.494.494 0 00-.618.343l-.472 1.651L.984.36a.5.5 0 00-.967.258l3.856 14.5a.5.5 0 00.479.371h.005a.498.498 0 00.48-.362l.97-3.394a.499.499 0 00-.343-.618z"}})])
          )
        }
      }
    